// The app version lives in the `<meta name="version">` tag of index.html, whose
// `%VITE_VERSION%` placeholder is replaced at deploy time. Read it at runtime —
// the JS bundle's `import.meta.env.VITE_VERSION` is baked at build time (empty when
// the build runs without that env var), so the meta tag is the real source.
const meta = document.querySelector('meta[name="version"]')?.getAttribute('content')?.trim()

/**
 * The running app version, from the `<meta name="version">` tag. Falls back to a
 * valid 4-part `major.minor.patch.increment` version in local dev, where the
 * `%VITE_VERSION%` placeholder is un-replaced: it flows into the `X-requestor`
 * header, and the API's version middleware 500s if it can't parse 4 parts.
 */
export const APP_VERSION = meta && meta !== '%VITE_VERSION%' ? meta : '0.0.0.0'
